import React, { useState } from "react";

/**
 * CallInPanel — host-side call-in controls + caller list.
 * Extracted from RadioHostStudio.
 */
export default function CallInPanel({ slug, token, callers, onOpen, onClose, onKick }) {
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);
  const callerIds = Object.keys(callers || {});
  const count = callerIds.length;
  const shareUrl = token ? `${window.location.origin}/radio/call/${token}` : null;
  const copy = async () => {
    if (!shareUrl) return;
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true); setTimeout(() => setCopied(false), 1500);
    } catch {}
  };
  return (
    <div data-testid="radio-host-callin" className="rounded-lg border border-white/10 bg-black/30">
      <button onClick={() => setOpen((v) => !v)} className="w-full flex items-center gap-2 px-3 py-2 text-left">
        <span className="text-[14px]">📞</span>
        <div className="flex-1 min-w-0">
          <div className="text-white font-black text-[11px] uppercase tracking-wider">Call-ins</div>
          <div className="text-white/50 text-[10px] truncate">
            {token ? (count > 0 ? `${count} caller${count > 1 ? "s" : ""} on air · Live WebRTC` : "Open · waiting for callers") : "Closed · tap Open to accept calls"}
          </div>
        </div>
        {token && <span className="inline-flex items-center gap-1 bg-emerald-500/20 text-emerald-200 border border-emerald-500/40 text-[9px] font-black px-2 py-0.5 rounded-full">LIVE</span>}
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-2">
          {!token ? (
            <button
              data-testid="callin-open"
              onClick={onOpen}
              className="w-full bg-emerald-500 hover:bg-emerald-400 text-black font-black text-[10px] py-1.5 rounded"
            >Open call-in line</button>
          ) : (
            <>
              <div className="flex items-center gap-1">
                <code data-testid="callin-url" className="flex-1 min-w-0 bg-black/50 border border-white/10 rounded px-2 py-1 text-[10px] font-mono text-white truncate" title={shareUrl}>{shareUrl}</code>
                <button data-testid="callin-copy" onClick={copy} className="bg-fuchsia-500 hover:bg-fuchsia-400 text-black font-black text-[9px] px-2 py-1 rounded">{copied ? "Copied" : "Copy"}</button>
              </div>
              <div className="text-white/50 text-[9px]">Share the link — callers tap it, grant mic, they're on air through your mix.</div>
              <div className="space-y-1" data-testid="callin-caller-list">
                {callerIds.length === 0 ? (
                  <div className="text-white/40 text-[10px] text-center py-2">No callers yet.</div>
                ) : callerIds.map((cid) => (
                  <div key={cid} className="flex items-center gap-2 bg-white/5 rounded p-1.5">
                    <span className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse shrink-0" />
                    <div className="flex-1 min-w-0 text-[10px] font-mono text-white truncate">Caller {cid.slice(0, 6)}</div>
                    <button onClick={() => onKick(cid)} className="bg-red-500/20 hover:bg-red-500/40 text-red-200 text-[9px] font-black px-2 py-0.5 rounded">Kick</button>
                  </div>
                ))}
              </div>
              <button
                data-testid="callin-close"
                onClick={onClose}
                className="w-full bg-white/5 hover:bg-red-500/30 border border-white/10 text-white/70 hover:text-red-200 font-black text-[10px] py-1.5 rounded"
              >Close call-in line</button>
            </>
          )}
        </div>
      )}
    </div>
  );
}
